/*=========================================================================================
  File Name: moduleAssignedChat.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleAssignedChatState.js";
import mutations from "./moduleAssignedChatMutations.js";
// import actions from "./moduleAssignedChatActions.js";
import getters from "./moduleAssignedChatGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  // actions,
  getters,
};
